import Rest from '@/services/Rest';

/**
 * @typedef {SaleTotalService}
 */
export default class SaleTotalService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/sale-total'
}
